import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { displayNum } from "../../../variables/numbersFunctions";
import autoTable from "jspdf-autotable";

export const generateSinistresExcel = (excelPreviewUrl) => {
    try {
        const grouped = {};
        excelPreviewUrl.forEach((item) => {
            const year = item.annee;
            const cat = item.categorie;
            if (!grouped[year]) grouped[year] = {};
            if (!grouped[year][cat]) grouped[year][cat] = [];
            grouped[year][cat].push(item);
        });

        const workbook = XLSX.utils.book_new();
        const sheet = XLSX.utils.json_to_sheet([]);
        let rowIdx = 0;

        const sortedYears = Object.keys(grouped).sort((a, b) => a - b);
        sortedYears.forEach((year) => {
            rowIdx += 1;
            XLSX.utils.sheet_add_aoa(sheet, [[`Année: ${year}`]], {
                origin: `A${rowIdx}`,
            });
            rowIdx += 1;

            const categories = Object.keys(grouped[year]).sort();
            categories.forEach((cat) => {
                const rows = grouped[year][cat];

                rowIdx += 1;
                XLSX.utils.sheet_add_aoa(sheet, [[`Catégorie: ${cat}`]], {
                    origin: `A${rowIdx}`,
                });
                rowIdx += 1;

                const headerRow2 = [
                    "ID",
                    "N° Sinistre",
                    "N°Police",
                    "Date Sinistre",
                    "Cumul paiements exos anterieurs",
                    "Paiements dans l'exercice",
                    "Provision de clôture",
                    "Total Charges sinistres",
                    "Cumul Recours exos anterieurs",
                    "Recours encaissés dans l'exercice",
                    "Prévision de recours à la clôture",
                    "Total des recours",
                ];
                XLSX.utils.sheet_add_aoa(sheet, [headerRow2], {
                    origin: `A${rowIdx}`,
                });
                rowIdx += 1;

                rows.forEach((r, id) => {
                    const dataRow = [
                        id + 1,
                        r.numeroSinistreM ? r.numeroSinistreM : r.numeroSinistreP,
                        r.numeroPoliceM ? r.numeroPoliceM : r.numeroPoliceP,
                        r.dateSinistre
                            ? new Date(r.dateSinistre).toLocaleDateString()
                            : "",
                        displayNum(r.cumulPaiementsExoAnterieurs || 0),
                        displayNum(r.paiementsExerciceEnCours || 0),
                        displayNum(r.provisionCloture || 0),
                        displayNum(r.totalCharges || 0),
                        displayNum(r.cumulRecoursExoAnterieurs || 0),
                        displayNum(r.recoursExerciceEnCours || 0),
                        displayNum(r.previsionCloture || 0),
                        displayNum(r.totalRecours || 0),
                    ];
                    XLSX.utils.sheet_add_aoa(sheet, [dataRow], {
                        origin: `A${rowIdx}`,
                    });
                    rowIdx += 1;
                });

                const totalRowData = [
                    `Total ${cat}`,
                    "",
                    "",
                    `${rows.length}`,
                    displayNum(rows.reduce((s, r) => s + (r.cumulPaiementsExoAnterieurs || 0), 0)),
                    displayNum(rows.reduce((s, r) => s + (r.paiementsExerciceEnCours || 0), 0)),
                    displayNum(rows.reduce((s, r) => s + (r.provisionCloture || 0), 0)),
                    displayNum(rows.reduce((s, r) => s + (r.totalCharges || 0), 0)),
                    displayNum(rows.reduce((s, r) => s + r.cumulRecoursExoAnterieurs, 0)),
                    displayNum(rows.reduce((s, r) => s + (r.recoursExerciceEnCours || 0), 0)),
                    displayNum(rows.reduce((s, r) => s + (r.previsionCloture || 0), 0)),
                    displayNum(rows.reduce((s, r) => s + (r.totalRecours || 0), 0)),
                ];
                XLSX.utils.sheet_add_aoa(sheet, [totalRowData], {
                    origin: `A${rowIdx}`,
                });
                rowIdx += 2;
            });
        });

        XLSX.utils.book_append_sheet(workbook, sheet, "Sinistres");

        const formattedDateTime = new Date()
            .toLocaleString("fr-FR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
            })
            .replace(/[:\/ ]/g, "-");
        const fileName = `DONNEES DU TABLEAU F DES ETATS CIMA ${formattedDateTime}.xlsx`;

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });
        const blob = new Blob([excelBuffer], {
            type: "application/octet-stream",
        });
        saveAs(blob, fileName);
    } catch (error) {
        console.error("Error generating Excel file:", error);
    }
};

export const drawHeaderSinistrePdfGenerator = (doc, pageWidth) => {
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 255);
    doc.setFont("helvetica", "bold");
    doc.text("POOL TPVM-VT GIE", pageWidth / 2, 10, { align: "center" });
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text("DONNEES DU TABLEAU F DES ETATS CIMA", pageWidth / 2, 17, {
        align: "center",
    });
    doc.setFontSize(9);
    doc.text(
        `Exercice d'inventaire : ${new Date().getFullYear()}`,
        pageWidth / 2,
        22,
        { align: "center" }
    );
};

const drawFooter = (doc, formattedDateTime) => {
    const pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        doc.setFontSize(9);
        doc.setTextColor(100);
        doc.text(
            `Généré le : ${formattedDateTime} par PoolIns`,
            14,
            pageHeight - 7
        );
        doc.text(
            `Page ${doc.internal.getCurrentPageInfo().pageNumber} / ${pageCount}`,
            pageWidth - 25,
            pageHeight - 7
        );
    }
};


export const sinistresPdfGenerator = (sinistres, doc, grouped, formattedDateTime) => {
    sinistres.forEach((item) => {
        const year = item.annee;
        const cat = item.categorie;
        if (!grouped[year]) grouped[year] = {};
        if (!grouped[year][cat]) grouped[year][cat] = [];
        grouped[year][cat].push(item);
    });

    let globalTotals = {
        totalSinistres: 0,
        cumulAnterieur: 0,
        enCours: 0,
        provision: 0,
        totalCharges: 0,
        totalRecours: 0,
        cumulRecoursExosAnterieurs: 0,
        recoursEncaisseExercice: 0,
        previsionRecoursCloture: 0
    };

    const sortedYears = Object.keys(grouped).sort((a, b) => a - b);

    sortedYears.forEach((year, yearIdx) => {
        const lastY = doc.lastAutoTable?.finalY || 20;
        doc.setFontSize(14);
        doc.text(`Année: ${year}`, 14, lastY + 10);

        const categories = Object.keys(grouped[year]).sort(); // VC before VL alphabetically
        categories.forEach((cat) => {
            const rows = grouped[year][cat];

            globalTotals.totalSinistres += rows.length;
            globalTotals.cumulAnterieur += rows.reduce((sum, s) => sum + Math.trunc(s.cumulPaiementsExoAnterieurs || 0), 0);
            globalTotals.enCours += rows.reduce((sum, s) => sum + Math.trunc(s.paiementsExerciceEnCours || 0), 0);
            globalTotals.provision += rows.reduce((sum, s) => sum + Math.trunc(s.provisionCloture || 0), 0);
            globalTotals.totalCharges += rows.reduce((sum, s) => sum + Math.trunc(s.totalCharges || 0), 0);
            globalTotals.cumulRecoursExosAnterieurs += rows.reduce((sum, s) => sum + Math.trunc(s.cumulRecoursExoAnterieurs || 0), 0);
            globalTotals.recoursEncaisseExercice += rows.reduce((sum, s) => sum + Math.trunc(s.recoursExerciceEnCours || 0), 0);
            globalTotals.previsionRecoursCloture += rows.reduce((sum, s) => sum + Math.trunc(s.previsionCloture || 0), 0);
            globalTotals.totalRecours += rows.reduce((sum, s) => sum + Math.trunc(s.totalRecours || 0), 0);


            const dataRows = rows.map((s, id) => [
                id + 1,
                s.numeroSinistreM ? s.numeroSinistreM : s.numeroSinistreP,
                s.numeroPoliceM ? s.numeroPoliceM : s.numeroPoliceP,
                s.dateSinistre ? new Date(s.dateSinistre).toLocaleDateString() : "",
                displayNum(Math.trunc(s.cumulPaiementsExoAnterieurs)),
                displayNum(Math.trunc(s.paiementsExerciceEnCours)),
                displayNum(Math.trunc(s.provisionCloture)),
                displayNum(Math.trunc(s.totalCharges)),
                displayNum(Math.trunc(s.cumulRecoursExosAnterieurs || 0)),
                displayNum(Math.trunc(s.recoursExerciceEnCours || 0)),
                displayNum(Math.trunc(s.previsionCloture || 0)),
                displayNum(Math.trunc(s.totalRecours || 0))
            ]);

            // ➕ Calculs des totaux
            const totalRow = [
                { content: `Total ${cat}`, colSpan: 3, styles: { halign: "right" } }, // N°Police + Date + Label Total
                `${rows.length}`, // colonnes texte vides
                displayNum(rows.reduce((sum, s) => sum + Math.trunc(s.cumulPaiementsExoAnterieurs || 0), 0)),
                displayNum(rows.reduce((sum, s) => sum + Math.trunc(s.paiementsExerciceEnCours || 0), 0)),
                displayNum(rows.reduce((sum, s) => sum + Math.trunc(s.provisionCloture || 0), 0)),
                displayNum(rows.reduce((sum, s) => sum + Math.trunc(s.totalCharges || 0), 0)),
                displayNum(rows.reduce((sum, s) => sum + Math.trunc(s.cumulRecoursExoAnterieurs || 0), 0)),
                displayNum(rows.reduce((sum, s) => sum + Math.trunc(s.recoursExerciceEnCours || 0), 0)),
                displayNum(rows.reduce((sum, s) => sum + Math.trunc(s.previsionCloture || 0), 0)),
                displayNum(rows.reduce((sum, s) => sum + Math.trunc(s.totalRecours || 0), 0))
            ];

            // ➕ Ajouter la ligne de totaux avec formatage
            const formattedTotalRow = totalRow.map((cell, i) => {
                return (i >= 4 && typeof cell === "number")
                    ? displayNum(cell)
                    : cell;
            });

            dataRows.push(formattedTotalRow);

            // ➕ Écrire le titre de la catégorie manuellement
            const yStart = doc.lastAutoTable?.finalY ? doc.lastAutoTable.finalY + 20 : 40;
            doc.setFontSize(12);
            doc.text(`Catégorie: ${cat}`, 14, yStart);

            autoTable(doc, {
                startY: yStart + 5,
                head: [
                    [
                        {
                            content: 'DETAILS SINISTRES',
                            colSpan: 4,
                            styles: {
                                halign: 'center',
                                fillColor: [204, 255, 255], // CCFFFF
                                lineWidth: 0.1,
                                lineColor: [0, 0, 0],
                                textColor: 20
                            }
                        },
                        {
                            content: 'CHARGES DE SINISTRES',
                            colSpan: 4,
                            styles: {
                                halign: 'center',
                                fillColor: [204, 255, 255],
                                lineWidth: 0.1,
                                lineColor: [0, 0, 0],
                                textColor: 20
                            }
                        },
                        {
                            content: 'RECOURS',
                            colSpan: 4,
                            styles: {
                                halign: 'center',
                                fillColor: [204, 255, 255],
                                lineWidth: 0.1,
                                lineColor: [0, 0, 0],
                                textColor: 20
                            }
                        }
                    ],
                    [
                        "ID", "N° Sinistre", "N°Police", "Date Sinistre",
                        "Cumul paiements exos anterieurs", "Paiements dans l'exercice", "Provision de clôture", "Total Charges sinistres",
                        "Cumul Recours exos anterieurs", "Recours encaissés dans l'exercice", "Prévision de recours à la clôture", "Total des recours"
                    ]
                ],
                body: dataRows,
                theme: 'striped',
                headStyles: {
                    fillColor: [204, 255, 255],
                    fontSize: 8,         // 🔽 taille réduite des entêtes
                    halign: 'center',
                    lineWidth: 0.1,
                    lineColor: [0, 0, 0],
                    textColor: 20
                },
                styles: {
                    fontSize: 7.5,       // 🔽 taille réduite des cellules
                    cellPadding: 2,      // 🔽 padding plus compact
                    overflow: 'linebreak',
                    valign: 'middle',
                    lineWidth: 0.1,
                    lineColor: [0, 0, 0]
                },
                columnStyles: {
                    4: { halign: 'right' },  // alignement à droite pour montants
                    5: { halign: 'right' },
                    6: { halign: 'right' },
                    7: { halign: 'right' },
                    8: { halign: 'right' },
                    9: { halign: 'right' },
                    10: { halign: 'right' },
                    11: { halign: 'right' }
                },
                bodyStyles: {
                    lineWidth: 0.1,
                    lineColor: [0, 0, 0]
                },
                margin: { top: 10, bottom: 10 }
            });
        });

    });

    const lastY = doc.lastAutoTable?.finalY || 20;
    doc.setFontSize(13);
    doc.text("Récapitulatif global des sinistres :", 14, lastY + 15);

    autoTable(doc, {
        startY: lastY + 20,
        head: [[
            "Total sinistres", "Total paiements exos antérieurs", "Paiements dans l'exo", "Provision de clôture", "Total charges",
            "Cumul Recours exos anterieurs", "Recours encaissés dans l'exercice", "Prévision de recours à la clôture", "Total des recours"
        ]],
        body: [[
            `${globalTotals.totalSinistres} sinistres`,
            displayNum(globalTotals.cumulAnterieur),
            displayNum(globalTotals.enCours),
            displayNum(globalTotals.provision),
            displayNum(globalTotals.totalCharges),
            displayNum(globalTotals.cumulRecoursExosAnterieurs),
            displayNum(globalTotals.recoursEncaisseExercice),
            displayNum(globalTotals.previsionRecoursCloture),
            displayNum(globalTotals.totalRecours),
        ]],
        styles: {
            fillColor: [230, 255, 230], // 🟩 vert clair (ou essaie [255, 255, 180] pour du jaune)
            fontStyle: 'bold',
            fontSize: 7.5,
        },
        headStyles: {
            fillColor: [22, 160, 133], // même style que les tableaux précédents
            textColor: 255
        },
        columnStyles: {
            0: { halign: 'left', cellWidth: 30 },
            4: { halign: 'right', cellWidth: 20 },  // alignement à droite pour montants
            5: { halign: 'right' },
            6: { halign: 'right' },
            7: { halign: 'right' },
            8: { halign: 'right' },
            9: { halign: 'right' },
            10: { halign: 'right' },
            11: { halign: 'right' }
        },
        margin: { top: 10 }
    });

    // // ➕ Ajouter le pied de page (date/heure) sur chaque page
    // const pageCount = doc.getNumberOfPages();
    // for (let i = 1; i <= pageCount; i++) {
    //     doc.setPage(i);
    //     doc.setFontSize(10);
    //     doc.setTextColor(150);
    //     doc.text(
    //         `Généré le : ${formattedDateTime}`,
    //         14,
    //         doc.internal.pageSize.height - 7
    //     );
    // }
    drawFooter(doc, formattedDateTime);
    // doc.save(`DONNEES DU TABLEAU F DES ETATS CIMA ${formattedDateTime}.pdf`);
    return doc.output('datauristring');
}